/* eslint-disable no-extra-boolean-cast */
import CONSTANT from "../../constants/constant";
import ModalDialog from "../Modal/Modal";
import { useState } from "react";
import Title from "../Utils/Title.styled";
import Stack from "../Utils/Stack.styled";
import Button from "../Button";
import CheckboxGroup from "../Checkbox/Checkbox";
import Paragraph from "../Utils/Paragraph.styled";
import Icon from "../Icon/Icon";
import { CreatePlaylist } from "./PlaylistModal.styled";
import { TextField } from "@mui/material";
import { useForm } from "react-hook-form";
import {
  createNewPlaylistByName,
  addVideoToPlaylist,
} from "../../helper/useApiHelper";
import usePlayListStore from "../../stores/playlistStore";
import { useErrorState } from "../../contexts/errorContext";
import { useStatus } from "../../contexts/statusContext";
import { usePlaylist } from "../../contexts/playlistContext";

const PlaylistModal = () => {
  const createPlaylist = usePlayListStore((state) => state.createPlaylist);
  const createPlaylistId = usePlayListStore((state) => state.createPlaylistId);
  const addVideo = usePlayListStore((state) => state.addVideo);
  const countPlaylists = usePlayListStore((state) => state.countPlaylists);
  const playlistState = usePlayListStore((state) => state.playlistState);
  const updateVideo = usePlayListStore((state) => state.updateVideo);
  const isUpdatedPlaylist = usePlayListStore(
    (state) => state.isUpdatedPlaylist
  );
  const resetIsUpdatedPlaylist = usePlayListStore(
    (state) => state.resetIsUpdatedPlaylist
  );

  const [showCreatePlaylistName, setShowCreatePlaylistName] = useState(false);
  const [currentVideoState, setCurrentVideoState] = useState(null);
  const { currentSelectedVideoDetails, setCurrentSelectedVideoDetails } =
    usePlaylist();
  const { setStatusKey } = useStatus();
  const { setIsError } = useErrorState();
  const { register, getValues, reset } = useForm();

  const getUpdatedCheckbox = (currentState) => {
    setCurrentVideoState(currentState);
  };

  const RenderCreatePlaylistNameButton = () => {
    return (
      <CreatePlaylist
        showBorder={countPlaylists > 0}
        onClick={() => setShowCreatePlaylistName(true)}
      >
        <Stack
          direction="row"
          alignItems="center"
          gap="8"
          paddingTop="8px"
          paddingBottom="8px"
          style={{
            cursor: "pointer",
          }}
        >
          <Icon type={CONSTANT.ICON.ADD} size="24px" />
          <Paragraph size="14px">Create New Playlist</Paragraph>
        </Stack>
      </CreatePlaylist>
    );
  };

  const RenderTextField = () => {
    return (
      <TextField
        label="Create your playlist name"
        variant="standard"
        fullWidth
        {...register("newPlaylistName")}
      />
    );
  };
  const RenderCreatePlaylistName = () => {
    if (!showCreatePlaylistName) {
      return <RenderCreatePlaylistNameButton />;
    }
    return <RenderTextField />;
  };

  const onHandlingPlaylist = () => {
    const newPlaylistName = getValues("newPlaylistName");
    if (!!newPlaylistName) {
      createPlaylist(newPlaylistName);
      createNewPlaylistByName(newPlaylistName);
      createNewPlaylistByName(newPlaylistName)
        .then((data) => {
          if (data && data.data && data.data.id) {
            createPlaylistId(newPlaylistName, data.data.id);
            addVideo(newPlaylistName, { ...currentSelectedVideoDetails });
            addVideoToPlaylist(data.data.id, currentSelectedVideoDetails).catch(
              () => setIsError(true)
            );
            setStatusKey(CONSTANT.STATUS_KEY.CREATED_PLAYLIST);
          }
        })
        .catch(() => {
          console.log("error");
          setIsError(true);
        });
    }

    if (currentVideoState) {
      updateVideo(currentSelectedVideoDetails, currentVideoState);
      if (isUpdatedPlaylist) {
        setStatusKey(CONSTANT.STATUS_KEY.UPDATED_PLAYLIST);
        resetIsUpdatedPlaylist();
      }
    }
    clearAllData();
  };

  const onCloseDialog = (val) => {
    if (val === CONSTANT.CLOSE) {
      clearAllData();
    }
  };

  const clearAllData = () => {
    setShowCreatePlaylistName(false);
    setCurrentSelectedVideoDetails(null);
    reset(() => ({
      newPlaylistName: "",
    }));
  };

  const headerMessage = () => {
    return countPlaylists > 0 ? "Select Your Playlist" : "Create Your Playlist";
  };

  if (currentSelectedVideoDetails) {
    return (
      <ModalDialog isOpen onClose={onCloseDialog}>
        <Stack
          direction="column"
          justifyContent="center"
          gap="24"
          alignItems="end"
        >
          <Title
            textAlign="center"
            width="100%"
            textTransform="uppercase"
            size="18px"
          >
            {headerMessage()}
          </Title>
          <Stack direction="column" gap="16" width="100%">
            {countPlaylists > 0 && (
              <CheckboxGroup
                lists={playlistState}
                onUpdateCheckbox={getUpdatedCheckbox}
              />
            )}
            <RenderCreatePlaylistName />
          </Stack>
          <Button
            padding="12px 24px"
            label="Done"
            onClick={onHandlingPlaylist}
          />
        </Stack>
      </ModalDialog>
    );
  }
};

export default PlaylistModal;
